<template>
<div>
  <Modal v-if="showShareModal === true" ref="shareModal" @close="showShareModal = false; rejected()">
    <template #modal-content-left>
      <h1 class="modal-title">Support us!</h1>
      <div class="modal-text">
          <p>❤️ We are a couple of indie devs trying to grow</p>
          <p>🔥 Just a little action means a lot to us</p>
          <p>🔎 How can you help?</p>
          <p>📡 Share it on your networks, it's free!</p>
      </div>
    </template>
    <template #modal-content-right>
      <h1 class="modal-title" style="padding-left: 10px; padding-right: 10px;">It'd be amazing if you share it with your friends 👇</h1>
      <div style="margin-top: 50px; display: flex; justify-content: center;">
        <TwitterShareButton @accepted="accepted()"/>
      </div>
    </template>
  </Modal>
  <div class="top-bar-background">
    <div class="tabs-nav-container">
      <div class="tabs-nav-column-container">
        <button class="tabs-nav-button-active" v-if="filter.dateFilter === 'n'"><u style="text-decoration: none;">🔥 Newest</u></button>
        <button class="tabs-nav-button" v-if="filter.dateFilter !== 'n'" @click="selectDateFilter('n')">🔥 Newest</button>
        <button class="tabs-nav-button-active" v-if="filter.dateFilter === 'd'" @click="selectDateFilter('d')"><u style="text-decoration: none;">🎯 Best of the day</u></button>
        <button class="tabs-nav-button" v-if="filter.dateFilter !== 'd'" @click="selectDateFilter('d')">🎯 Best of the day</button>
        <button class="tabs-nav-button-active" v-if="filter.dateFilter === 'w'" @click="selectDateFilter('w')"><u style="text-decoration: none;">💪 Best of the week</u></button>
        <button class="tabs-nav-button" v-if="filter.dateFilter !== 'w'" @click="selectDateFilter('w')">💪 Best of the week</button>
        <button class="tabs-nav-button-active" v-if="filter.dateFilter === 'm'" @click="selectDateFilter('m')"><u style="text-decoration: none;">🏆 Best of the month</u></button>
        <button class="tabs-nav-button" v-if="filter.dateFilter !== 'm'" @click="selectDateFilter('m')">🏆 Best of the month</button> 
      </div>
    </div>
  </div>

  <div class="sub-header-container">
    <button class="primary-button" style="float: right; margin-right: 0px;" v-if="$store.state.auth.isLogged === false" @click="$store.state.showLoginModal = true">Submit Thread</button>
    <button class="primary-button" style="float: right; margin-right: 0px;" v-if="$store.state.auth.isLogged === true" @click="$router.push({ path: '/post-thread' })">Submit Thread</button>

    <TagsCollection ignore-max-tags has-to-popup-login ref="tagsCollection" @added-tags="primaryTagAdded($event)" @show-login="$store.state.showLoginModal = true; $refs.tagsCollection.showTags = false"/>
    
    <div class="tags-button-container">
      <Tag class="tags-button" :tag="tag" v-for="(tag) in filter.primaryTags" :key="tag" @removed-tag="removedPrimaryTag($event)"/>
      <button id="clear-filter-button" class="secondary-button" v-if="filter.primaryTags.length !== 0" @click="clearFilter()">Clear</button>
    </div>

    <h1 style="text-align: center; padding-top: 20px; color: var(--secondary-text-color);" v-if="showThreads.length === 0 && !showLoading">Nothing found. 👋 If you have a nice Twitter thread to share, just post it clicking <a v-if="!$store.state.auth.isLogged" @click="$store.state.showLoginModal = true">here</a><a v-if="$store.state.auth.isLogged" @click="$router.push({  path: '/post-thread' })">here</a>. This a brand new site and needs juicy threads to start growing.</h1>
  </div>

  <div class="page-container">
      <Thread
        v-for="(t, index) in threads" 
        :key="`thread-${index}`" 

        :thread="t"
        show-read-it="true"
      />
  </div>

  <div v-if="showThreads.length > 0" class="pagination-container">
    <button class="previous-page-button" v-if="page > 1" @click="previousPage"><i class="fas fa-arrow-left previous-page-button-icon"></i>Previous</button>
    <button class="next-page-button" v-if="page < lastPage" @click="nextPage">Next<i class="fas fa-arrow-right next-page-button-icon"></i></button>
  </div>

  <Feedback/>
</div>
</template>

<script>
import Tag from '@/components/Tag'
import Thread from '@/components/Thread'
import Modal from '@/components/Modal'
import TagsCollection from '@/components/TagsCollection'
import Feedback from '@/components/Feedback'
import TwitterShareButton from '@/components/TwitterShareButton'

import firebase from '@/firebase'

export default {

  components: {
    Modal,
    Tag,
    TagsCollection,
    Thread,
    Feedback,
    TwitterShareButton,
  },

  computed: {
    showThreads() {
      const start = (this.page - 1) * this.pageSize
      const end = start + this.pageSize
      return this.threads.slice(start, end)
    },
  },

  props: {
     pageSize: {
      type: Number,
      default: 10
    },
  },

  data() {
    return {
      showShareModal: false,
      delayShowShareModalSeconds: [10],
      showShareModalTimes: 1,
      showedShareModalCount: +localStorage.getItem('showedShareModalCount') || 0,
      showMobileFilter: false,
      page: 1,
      lastPage: 1,
      threads: [],
      filter: {
        primaryTags: [],
        dateFilter: 'n',
      },
    }
  },

  mounted() {
    this.startShareCountdown()
    this.get()
  },

  watch: {
    showShareModal(){
      if(this.showShareModal === true){
        window.twttr.widgets.load()
      }
    },
  },

  methods: {
    accepted() {
      firebase.analytics.logEvent('share_twitter_accepted')
    },

    rejected() {
      firebase.analytics.logEvent('share_twitter_rejected')
    },

    startShareCountdown() {
      this.shareCountdown = this.delayShowShareModalSeconds.pop()
      setInterval(() => {
        if(this.showedShareModalCount >= this.showShareModalTimes){
          return
        }
        if(this.shareCountdown == null){
          return
        }
        if(this.showShareModal === true){
          return
        }
        if(this.shareCountdown < 0){
          this.shareCountdown = this.delayShowShareModalSeconds.pop()
          this.showShareModal = true
          this.showedShareModalCount++
          localStorage.setItem('showedShareModalCount', this.showedShareModalCount)
          return
        }
        this.shareCountdown--
      }, 1 * 1000)
    },

    selectDateFilter(mode) {
      this.filter.dateFilter = mode
      this.get()
    },

    primaryTagAdded(tag) {
      this.filter.primaryTags.push(tag)
      this.get()
      this.$refs.tagsCollection.showTags = false
    },

    removedPrimaryTag(tag) {
      this.$refs.tagsCollection.removeTag(tag)
      const i = this.filter.primaryTags.indexOf(tag) 
      const exist = i > -1
      if (exist) {
        this.filter.primaryTags.splice(i, 1);
      }
      this.get()
    },

    clearFilter() {
      this.filter.primaryTags = []
      this.$refs.tagsCollection.tags = []
      this.get()
    },

    select(ref, model){
      ref.focus()
      ref.setSelectionRange(0, model.length)
    },

    capitalize(s) {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },

    selectedFilter() {
      this.get()
    },

    async get() {
      this.$store.state.showLoading = true

      this.threads = []
      let term = ``
      this.page = 1

      const ref = firebase.firestore.collection("threads2")
      let query = ref.orderBy('createdAt').orderBy('likes')

      if(this.filter.primaryTags.length !== 0){
        const param = this.filter.primaryTags.map(t => t.toLowerCase())
        query = query.where("primaryTags", "array-contains-any", param)
        term += `&primaryTags=${param.join(',')}`
      }

      if(this.filter.dateFilter === 'd'){
        query = query
          .where('createdAt', '>', firebase.Timestamp.fromDate(new Date().addDays(-1)))
          .where('createdAt', '<', firebase.Timestamp.fromDate(new Date()))
      }

      if(this.filter.dateFilter === 'w'){
        query = query
          .where('createdAt', '>', firebase.Timestamp.fromDate(new Date().addWeeks(-1)))
          .where('createdAt', '<', firebase.Timestamp.fromDate(new Date()))
      }

      if(this.filter.dateFilter === 'm'){
        query = query
          .where('createdAt', '>', firebase.Timestamp.fromDate(new Date().addMonths(-1)))
          .where('createdAt', '<', firebase.Timestamp.fromDate(new Date()))
      }

      term += `&dateFilter=${this.filter.dateFilter}}`

      query
        .get()
        .then(async (snap) => {
          this.lastPage = Math.ceil(snap.size / this.pageSize)

          for(const doc of snap.docs){
            const tweet = doc.data()
            tweet.id = doc.id
            tweet.ref = doc.ref

            this.threads.push(tweet)
          }

          this.threads.sort(this.getSorter())

          this.$store.state.showLoading = false
      })
      .catch(function(error) {
          console.error("Error getting documents: ", error)
      })

      firebase.analytics.logEvent('search', { search_term: term })
    },

    getSorter() {
      if(this.filter.dateFilter === 'n'){
        return (first, second) => {
          const r = second.createdAt.toMillis() < first.createdAt.toMillis()
          return r ? -1 : 1
        }
      }

      return (first, second) => {
              return second.likes - first.likes
            }
    },

    nextPage() {
      this.page++
      window.scrollTo(0,0);
      window.twttr.widgets.load()
    },

    previousPage() {
      this.page--
      window.scrollTo(0,0);
      window.twttr.widgets.load()
    },
  }
}
</script>

<style scoped>
h1{
  cursor: default;
}
a{
  cursor: pointer;
}
.header-container{
  background-color: transparent;
  max-width: 1100px;
  padding: 10px 3rem 10px 3rem;
  margin: 0 auto;
}
.sub-header-container{
  background-color: var(--global-background-color);
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0 auto 10px auto;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 5;
}
.page-container{
  max-width: 1100px;
  min-height: 1100px;
  padding: 0 3rem;
  margin: 0 auto;
}
.pagination-container{
  background-color: none;
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0px auto 10px auto;
  height: 100px;
}
.top-nav img{
  float: left;
  cursor: pointer;
}
.top-nav button:hover{
  background-color: orange;
  color: white;
}
.tags-button-container{
  display: block;
  text-align: left;
  width: 100%;
  clear: both;
}
.filter-button-mobile{
  visibility: hidden;
}
@media (max-width: 760px){
  .header-container{
  padding: 0 0.5rem;
  }
  .tabs-nav-container{
  padding: 0 0.5rem;
  }
  .sub-header-container{
  padding: 0 0.5rem;
  }
  .page-container{
  padding: 0 0.5rem;
  }
  .pagination-container{
  padding: 0 0.5rem;
  }
  .website-name{
    font-size: 15px;
  }
  .website-name-container img{
    width: 22px;
  }
  .website-name-container p{
    display: none;
  }
  .filter-button-mobile{
    visibility: visible;
    background-color: var(--secondary-dark-color);
    color: var(--secondary-text-color);
    border: 2px solid;
    border-color: transparent;
    text-align: center;
    text-decoration: none;
    font-weight: bold;
    width: 100%;
    height: 3.2rem;
    margin: 0px;
    bottom: 0;
    position: fixed;
  }
}

</style>
